import { CollectedPreviewItem } from "@apiserver-rest/ponder-data-client-base";

/**
 * Wrapper around a {@link CollectedPreviewItem} that helps handle visibility and sorting.
 */
export class FilteredPreviewItem {
    public isVisible?: boolean;
    public currentIndex!: number;
    public mask: number = 0;

    public constructor(
        public previewItem: CollectedPreviewItem, 
        public originalIndex: number) {
            this.currentIndex = originalIndex;
    }
}

